<script>
import FooterView from '../../shared/views/MainFooterView';
import BrandLogo from '../../shared/BrandLogo.vue';
export default {
  name: 'AboutPageView',
  components: {
        'brand-logo': BrandLogo,
    'footer-view': FooterView,
  },
};
</script>

<template>
  <div class="public-page-wrapper">
    <!-- Header -->
    <header class="public-header">
      <div class="public-header__inner">
        <router-link to="/">
          <brand-logo variant="dark" />
        </router-link>
        <nav class="public-header__nav">
          <router-link to="/">Inicio</router-link>
          <router-link to="/acerca" class="active">Acerca</router-link>
          <router-link to="/cursos">Cursos</router-link>
          <router-link to="/noticias">Noticias</router-link>
          <router-link to="/contacto">Contacto</router-link>
        </nav>
        <div class="public-header__actions">
          <router-link
            to="/login"
            class="btn-outline"
          >
            Iniciar Sesión
          </router-link>
          <router-link
            to="/registrarse"
            class="btn-fill"
          >
            Registrarse
          </router-link>
        </div>
      </div>
    </header>

    <!-- Hero -->
    <section class="public-hero">
      <div class="public-hero__inner">
        <nav class="public-hero__nav">
          <router-link to="/">Inicio</router-link>
          <span>/</span>
          <a
            href="#"
            class="active"
          >Acerca</a>
        </nav>
        <h1 class="public-hero__title">Acerca de AppMisionate</h1>
        <p class="public-hero__subtitle">Conoce nuestra historia, misión y el equipo que hace posible la educación en línea de calidad.</p>
      </div>
    </section>

    <!-- Body -->
    <main class="public-body">

      <!-- Origins -->
      <div class="public-card mb-40">
        <div class="public-card__accent-bar" />
        <h3>Nuestros Orígenes</h3>
        <p>
          AppMisionate es una institución impulsada por el experimentado académico
          <strong>Dr. Erick Gastélum</strong>, quien cuenta con más de 12 años de trayectoria
          en el ámbito educativo, preparando a los aspirantes de diferentes carreras universitarias,
          contando con miles de casos de éxito que hablan de la calidad y profesionalismo.
        </p>
        <p>
          A lo largo de estos años, hemos desarrollado una metodología única que combina
          simuladores con contenido real como en los exámenes oficiales, retroalimentación
          inmediata y acompañamiento académico personalizado, logrando que miles de estudiantes
          cumplan su meta de ingresar a la universidad.
        </p>
      </div>

      <!-- Mission & Vision -->
      <div class="row mb-40">
        <div class="col-md-6">
          <div class="public-card">
            <div class="public-card__accent-bar" />
            <h3>Nuestra Misión</h3>
            <p>
              Ofrecer una formación educativa, a través de un servicio de calidad y
              profesionalismo, permitiendo a nuestros alumnos el acceso a la universidad
              logrando con ello la realización de sus proyectos de vida.
            </p>
            <router-link
              to="/registrarse"
              class="public-card__link"
            >
              Únete a nuestra familia <i class="uil uil-arrow-right" />
            </router-link>
          </div>
        </div>
        <div class="col-md-6">
          <div class="public-card">
            <div class="public-card__accent-bar" />
            <h3>Nuestra Visión</h3>
            <p>
              Ser una empresa líder en asesorías educativas, a través de un servicio
              educativo de calidad con un gran compromiso social pleno de valores y
              principios.
            </p>
            <router-link
              to="/acerca"
              class="public-card__link"
            >
              Conoce más de nosotros <i class="uil uil-arrow-right" />
            </router-link>
          </div>
        </div>
      </div>

      <!-- Offices -->
      <div class="public-card mb-40">
        <div class="public-card__accent-bar" />
        <h3>Nuestras Oficinas</h3>
        <p style="margin-bottom: 24px;">
          Contamos con oficinas estratégicamente ubicadas para brindarte atención personalizada.
        </p>
        <div class="row">
          <div class="col-md-4">
            <div class="contact-info-card">
              <div class="contact-info-card__icon">
                <i class="uil uil-map-marker-alt" />
              </div>
              <h4>Mexicali, Baja California</h4>
              <p>Calzada Macristy de Hermosillo #881, República Mexicana, Mexicali, B.C.</p>
              <p style="margin-top:8px; color:#0D47A1; font-weight:500;">
                <i class="uil uil-phone" /> 686 125 3218
              </p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="contact-info-card">
              <div class="contact-info-card__icon">
                <i class="uil uil-map-marker-alt" />
              </div>
              <h4>Tijuana, Baja California</h4>
              <p>Av. Revolución #1785, Zona Centro, Tijuana, B.C. (Sala ACDA)</p>
              <p style="margin-top:8px; color:#0D47A1; font-weight:500;">
                <i class="uil uil-phone" /> 686 125 3218
              </p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="contact-info-card">
              <div class="contact-info-card__icon">
                <i class="uil uil-map-marker-alt" />
              </div>
              <h4>Ensenada, Baja California</h4>
              <p>Av. Rayón 294, Col. Obrera, Ensenada B.C.</p>
              <p style="margin-top:8px; color:#0D47A1; font-weight:500;">
                <i class="uil uil-phone" /> 686-125-3218
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Values -->
      <div class="public-card">
        <div class="public-card__accent-bar" />
        <h3>Nuestros Valores</h3>
        <div class="row">
          <div class="col-md-3">
            <div style="text-align:center; padding:20px;">
              <div style="width:56px; height:56px; background:#EEF5FC; border-radius:14px; display:flex; align-items:center; justify-content:center; margin:0 auto 12px;">
                <i class="uil uil-graduation-cap" style="font-size:26px; color:#0D47A1;" />
              </div>
              <h4 style="margin:0 0 6px; font-size:0.9375rem;">Excelencia</h4>
              <p style="font-size:0.8125rem; margin:0;">Calidad en cada recurso educativo</p>
            </div>
          </div>
          <div class="col-md-3">
            <div style="text-align:center; padding:20px;">
              <div style="width:56px; height:56px; background:#EEF5FC; border-radius:14px; display:flex; align-items:center; justify-content:center; margin:0 auto 12px;">
                <i class="uil uil-heart" style="font-size:26px; color:#0D47A1;" />
              </div>
              <h4 style="margin:0 0 6px; font-size:0.9375rem;">Compromiso</h4>
              <p style="font-size:0.8125rem; margin:0;">Con el éxito de cada estudiante</p>
            </div>
          </div>
          <div class="col-md-3">
            <div style="text-align:center; padding:20px;">
              <div style="width:56px; height:56px; background:#EEF5FC; border-radius:14px; display:flex; align-items:center; justify-content:center; margin:0 auto 12px;">
                <i class="uil uil-shield" style="font-size:26px; color:#0D47A1;" />
              </div>
              <h4 style="margin:0 0 6px; font-size:0.9375rem;">Integridad</h4>
              <p style="font-size:0.8125rem; margin:0;">Transparencia y honestidad</p>
            </div>
          </div>
          <div class="col-md-3">
            <div style="text-align:center; padding:20px;">
              <div style="width:56px; height:56px; background:#EEF5FC; border-radius:14px; display:flex; align-items:center; justify-content:center; margin:0 auto 12px;">
                <i class="uil uil-users-alt" style="font-size:26px; color:#0D47A1;" />
              </div>
              <h4 style="margin:0 0 6px; font-size:0.9375rem;">Comunidad</h4>
              <p style="font-size:0.8125rem; margin:0;">Juntos en el camino académico</p>
            </div>
          </div>
        </div>
      </div>

    </main>

    <footer-view />
  </div>
</template>

<style scoped>
.mb-40 {
  margin-bottom: 40px;
}
</style>
